import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const tomos = [{
  number: 'T1',
  title: 'Pensar como un artesano japonés',
  subtitle: 'La base que nadie te enseña',
  content: ['Los 5 principios japoneses aplicados', 'Paleta de colores con marcas argentinas', 'Errores que arruinan el estilo']
}, {
  number: 'T2',
  title: 'Tu taller en cualquier espacio',
  subtitle: 'Sabés exactamente qué comprar y dónde',
  content: ['Herramientas esenciales, proveedores argentinos y setup de espacio mínimo']
}, {
  number: 'T3',
  title: 'Tu primer mueble en 48 horas',
  subtitle: 'Banqueta, repisa flotante y mesa ratona con planos completos',
  content: ['Planos detallados con medidas exactas, lista de materiales y paso a paso fotográfico']
}, {
  number: 'T4',
  title: 'Nivel siguiente',
  subtitle: 'Escritorio, rack de TV y cama plataforma con análisis de precio de venta',
  content: ['Proyectos avanzados con técnicas profesionales y cálculo de rentabilidad']
}, {
  number: 'T5',
  title: 'Convertí tu habilidad en negocio',
  subtitle: 'Fórmula de precio, sistema de ventas y roadmap de 0 a $3000 USD por mes',
  content: ['Estrategia comercial completa, canales de venta y escalamiento del negocio']
}, {
  number: 'T6',
  title: 'El taller profesional',
  subtitle: 'Técnica Shou Sugi Ban, diseño propio y cómo trabajar con arquitectos',
  content: ['Técnicas premium, diseño personalizado y networking profesional']
}];
export function Tomos() {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  return <section className="py-8 md:py-16 px-4 bg-[#F5F0E8]" data-id="element-284">
      <div className="max-w-5xl mx-auto" data-id="element-285">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-5xl font-bold text-center mb-2 md:mb-4" data-id="element-286">
          CONTENIDO COMPLETO
        </motion.h2>

        <motion.h3 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-lg md:text-2xl text-center mb-1 md:mb-2" data-id="element-287">
          LOS 6 TOMOS
        </motion.h3>

        <p className="text-center text-sm md:text-base text-[#2B2724]/70 mb-6 md:mb-8" data-id="element-288">
          Tu hoja de ruta para dominar la fabricación y el negocio Japandi
        </p>

        <div className="space-y-3 md:space-y-4 mb-4 md:mb-6" data-id="element-289">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.05
        }} className="bg-white rounded-lg border border-[#2B2724]/10 overflow-hidden" data-id="element-290">
              <button onClick={() => setExpandedIndex(expandedIndex === index ? null : index)} className="w-full p-4 md:p-6 text-left flex items-center justify-between hover:bg-[#F5F0E8]/50 transition-colors" aria-expanded={expandedIndex === index} data-id="element-291">
                <div className="flex-1 pr-2" data-id="element-292">
                  <div className="flex items-center gap-2 md:gap-3 mb-1 md:mb-2" data-id="element-293">
                    <span className="bg-[#C2613A] text-white px-2 py-0.5 md:px-3 md:py-1 rounded text-xs md:text-sm font-bold" data-id="element-294">
                      {tomo.number}
                    </span>
                    <h4 className="font-bold text-sm md:text-lg" data-id="element-295">
                      {tomo.title}
                    </h4>
                  </div>
                  <p className="text-xs md:text-sm text-[#2B2724]/70" data-id="element-296">
                    {tomo.subtitle}
                  </p>
                </div>
                <motion.div animate={{
              rotate: expandedIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="flex-shrink-0" data-id="element-297">
                  <ChevronDown className="w-5 h-5 md:w-6 md:h-6 text-[#C2613A]" data-id="element-298" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-299">
                {expandedIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-300">
                    <div className="px-4 pb-4 md:px-6 md:pb-6 border-t border-[#2B2724]/10 pt-3 md:pt-4" data-id="element-301">
                      <ul className="space-y-2" data-id="element-302">
                        {tomo.content.map((item, i) => <li key={i} className="flex items-start gap-2 text-xs md:text-sm" data-id="element-303">
                            <span className="text-[#C2613A] mt-0.5 md:mt-1" data-id="element-304">
                              ✓
                            </span>
                            <span data-id="element-305">{item}</span>
                          </li>)}
                      </ul>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        <p className="text-center text-xs md:text-sm text-[#2B2724]/60" data-id="element-306">
          Tocá cada tomo para ver lo que incluye 👆
        </p>
      </div>
    </section>;
}